import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { VerificationQueue } from '../../components/admin/VerificationQueue';
import { motion } from 'framer-motion';
export function TenantVerification() {
  return <div className="flex min-h-screen bg-gray-50 pb-16 lg:pb-0" data-id="element-3402">
      <Sidebar data-id="element-3403" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-3404">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3405">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3406">
            <div className="mb-8" data-id="element-3407">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-3408">
                Tenant Verification
              </h1>
              <p className="mt-1 text-sm text-gray-500" data-id="element-3409">
                Review and approve tenant documents and risk scores.
              </p>
            </div>

            <VerificationQueue data-id="element-3410" />
          </motion.div>
        </div>
      </main>
    </div>;
}